// import React, { useState } from 'react';

import React, { useState, useRef } from 'react';
import {
    Box,
    Typography,
    Avatar,
    TextField,
    IconButton,
    MenuItem,
    Paper,
    Radio,
    InputAdornment,
    Popper,
    ClickAwayListener
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CloseBlackIcon } from '../../../icons';

const projects = [
    { id: 1, name: 'Project Quantum', image: '', code: 'PQ', description: 'Description 1' },
    { id: 2, name: 'Digital Marketing', image: '', code: 'DM', description: 'Description 2' },
    { id: 3, name: 'SkyGrid', image: '', code: 'SG', description: 'Description 3' },
    { id: 4, name: 'Video Editor', image: '', code: 'VE', description: 'Description 4' },
];

const getInitials = (name) => {
    const words = name.split(' ');
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : name.slice(0, 2).toUpperCase();
};


const SingleSelectDroupdown = ({ selectedProject, setSelectedProject }) => {

    const [search, setSearch] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const anchorRef = useRef(null);

    const filteredProjects = projects.filter((p) =>
        p.name.toLowerCase().includes(search.toLowerCase())
    );

    const handleProjectSelect = (project) => {
        setSelectedProject(project);
        setDropdownOpen(false);
    };

    const handleRemove = () => {
        setSelectedProject(null);
    };

    // Dummy user and project details (can be passed via props)
    const user = {
        name: 'Salona Mishra',
        image: '/assets/images/users/user1.png',
    };

    const project = {
        name: 'Project Quantum',
        image: '',
        description: 'Worked Desk 1',
    };

    return (
        <>
            {/* Project Dropdown */}
            <Box mb={2}>
                <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                    <div>
                        {/* <Typography fontWeight={500} mb={'6px'} sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36' }}>Project*</Typography> */}
                        <TextField
                            fullWidth
                            placeholder="Select Project"
                            inputRef={anchorRef}
                            value={selectedProject?.name || ''}
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <ArrowDropDownIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                height: '40px',
                                color:'#64748B',
                                '& .MuiOutlinedInput-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    border: '1px solid #D0D5DD',
                                    paddingRight: 1,
                                    color: '#64748B',
                                    fontFamily: 'Manrope',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none', // removes double border from default outline
                                     color:'#64748B',
                                },
                            }}
                        />

                        <Popper
                            open={dropdownOpen}
                            anchorEl={anchorRef.current}
                            style={{ zIndex: 1300, width: anchorRef.current?.offsetWidth, }}
                        >
                            <Paper sx={{ mt: 1, maxHeight: 250, overflowY: 'auto' }}>
                                <Box p={1} sx={{ position: 'sticky', top: '0', zIndex: '9', background: '#fff', }}>
                                    <TextField
                                        placeholder="Search Project"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        fullWidth
                                        size="small"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '100px',
                                                fontFamily: 'Manrope',
                                            },
                                        }}
                                    />
                                </Box>
                                {filteredProjects.map((project) => (
                                    <MenuItem key={project.id} onClick={() => handleProjectSelect(project)}>
                                        <Radio checked={selectedProject?.id === project.id} value={project.id} />
                                        <Avatar sx={{ width: 32, height: 32, mr: 2, fontSize: '14px', background: '#0067C7', fontFamily: 'Manrope', }} src={project.image}>
                                            {!project.image && getInitials(project.name)}
                                        </Avatar>
                                        <Typography sx={{ fontFamily: 'Manrope', }}>{project.name}</Typography>
                                    </MenuItem>
                                ))}
                            </Paper>
                        </Popper>
                    </div>
                </ClickAwayListener>
            </Box>

            {/* Selected project display */}
            {selectedProject && (
                <Box
                    mb={2}
                    p={1}
                    border="1px solid #DFDFDF"
                    borderRadius={100}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        background: '#F6F6F6',
                        height: '50px',
                        fontFamily: 'Manrope',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Avatar src={selectedProject.image} sx={{ fontSize: '14px', background: '#0067C7', width: '34px', height: '34px', fontFamily: 'Manrope', }}>
                            {!selectedProject.image && getInitials(selectedProject.name)}
                        </Avatar>
                        <Box>
                            <Typography sx={{ color: '#373737', fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope', }}>{selectedProject.name}</Typography>
                            <Typography sx={{ color: '#9095A1', fontSize: '10px', fontFamily: 'Manrope', }}>
                                {selectedProject.description}
                            </Typography>
                        </Box>
                    </Box>
                    <IconButton onClick={handleRemove}>
                        <CloseBlackIcon />
                    </IconButton>
                </Box>
            )}
        </>
    );
}

export default SingleSelectDroupdown;
